import { render, staticRenderFns } from "./MatchMobileResults.vue?vue&type=template&id=24eb3c51"
import script from "./MatchMobileResults.vue?vue&type=script&lang=js"
export * from "./MatchMobileResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports